require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./utils"));
	else if(typeof define === 'function' && define.amd)
		define(["./utils"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./utils")) : factory(root["./utils"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__4__) {
return (window["wpBaUiCarbonToolkit"] = window["wpBaUiCarbonToolkit"] || []).push([[41],{

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 10:
/***/ (function(module, exports) {

module.exports = require("style-loader/lib/addStyles");

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireWildcard");

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 370:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(371);


/***/ }),

/***/ 371:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;

var _Paragraph = _interopRequireDefault(__webpack_require__(372));

exports["default"] = _Paragraph["default"];
exports.Paragraph = _Paragraph["default"];

/***/ }),

/***/ 372:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(8));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _utils = __webpack_require__(4);

var _Paragraph = _interopRequireDefault(__webpack_require__(373));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var paragraphClassName = _Paragraph["default"].paragraphClassName.replace(/"/g, '');

var sanitize = _utils.propsUtils.sanitize;

var Paragraph = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(Paragraph, _Component);

  function Paragraph() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = Paragraph.prototype;

  _proto.render = function render() {
    var _cx;

    var _this$props = this.props,
        children = _this$props.children,
        onClick = _this$props.onClick,
        style = _this$props.style,
        className = _this$props.className,
        fontWeight = _this$props.fontWeight,
        fontSize = _this$props.fontSize,
        primary = _this$props.primary,
        others = (0, _objectWithoutPropertiesLoose2["default"])(_this$props, ["children", "onClick", "style", "className", "fontWeight", "fontSize", "primary"]);
    var classNames = (0, _utils.classnames)(paragraphClassName, (_cx = {}, _cx[fontWeight] = fontWeight, _cx[fontSize] = fontSize, _cx.primary = primary, _cx.clickable = typeof onClick !== 'undefined', _cx));
    var pProps = (0, _extends2["default"])({}, sanitize(others, Paragraph), {
      className: classNames + " " + className,
      style: style,
      onClick: onClick
    });
    return /*#__PURE__*/_react["default"].createElement("p", pProps, children);
  };

  return Paragraph;
}(_react.Component);

exports["default"] = Paragraph;
(0, _defineProperty2["default"])(Paragraph, "propTypes", {
  /** Children to be inserted in the paragraph tag */
  children: _propTypes["default"].node,

  /** Function that will get called on click of Paragraph component */
  onClick: _propTypes["default"].func,

  /** Style object to be passed as the inline styling */
  style: _propTypes["default"].object,

  /** Name of class to be applied to component */
  className: _propTypes["default"].string,

  /** Change the font weight of the component */
  fontWeight: _propTypes["default"].oneOf(['normal', 'bold']),

  /** Change the font size of the component */
  fontSize: _propTypes["default"].oneOf(['small', 'normal']),

  /** Change the color of the text to primary */
  primary: _propTypes["default"].bool
});
(0, _defineProperty2["default"])(Paragraph, "defaultProps", {
  style: {},
  className: '',
  primary: false
});

/***/ }),

/***/ 373:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(374);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"modules":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(10)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {}

/***/ }),

/***/ 374:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(undefined);
// imports


// module
exports.push([module.i, ".ba-common-paragraph.is-small{font-size:.875rem;font-weight:400;line-height:1.125rem}.ba-common-paragraph{margin:16px 0}[dir=\"ltr\"].ba-common-paragraph{text-align:left}[dir=\"rtl\"].ba-common-paragraph{text-align:right}[dir=\"ltr\"] .ba-common-paragraph,.ba-common-paragraph{text-align:left}[dir=\"rtl\"] .ba-common-paragraph{text-align:right}.ba-common-paragraph.is-clickable{cursor:pointer}.ba-common-paragraph{margin:16px 0;color:#343334;font-size:1rem}.ba-common-paragraph.is-bold{font-weight:600}.ba-common-paragraph.is-primary{color:#1f57a4;color:hsla(var(--primary1-h, 214.73684), var(--primary1-s, 68.20513%), var(--primary1-l, 38.23529%), 1)}\n", ""]);

// exports
exports.locals = {
	"paragraphClassName": "\"ba-common-paragraph\""
};

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__4__;

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/inheritsLoose");

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/objectWithoutPropertiesLoose");

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = require("css-loader/lib/css-base");

/***/ })

},[[370,0]]]);
});